import PropTypes from "prop-types";
import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { multilanguage } from "redux-multilanguage";
import { AuthContext } from "../../common/Auth";
import { useThemeSettings } from "../../layouts/state/useThemeSettings";
import useWindowDimensions from "./state/useWindowDimensions";

import { SlideMenu } from 'primereact/slidemenu';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import { usePaymentMethodSettings } from '../../layouts/state/usePaymentMethodSettings'
import { useNavMenuFilter } from "./state/useNavMenuFilter";
import { REPORT_BUILDER_PATH_NAME } from '../../constant/headerMenuItems'
import { useGetReportUrlQuery } from '../../redux/api/reportBuilderApi'
import { styled } from "@mui/material";

const RollOverMenu = styled("ul")(({menuClass, marginLeft, marginTop, submenuBackGroundStyle}) => ({
  paddingTop: "0 !important",
  width: "200px !important",
  marginRight: menuClass === 'submenu-right' ? (marginLeft + "%") : undefined,
  marginLeft: menuClass === 'submenu-left' ? (marginLeft + "%") : undefined,
  marginTop: (marginTop + "px") || "0", 
  background: "none !important",

  "ul": {
   marginTop: "0",
  },
  "li": {
    position: "unset",
  },

  ".p-slidemenu": {
    width: "100%",
    background: submenuBackGroundStyle?.backgroundColor,
    border: "none",
    ".p-menuitem": {
      width: "100%",
      ".p-submenu-list.p-active-submenu": {
        paddingBottom: "50px",
      },
    },
    ".p-slidemenu-wrapper": {
      maxHeight: "300px",
    },
    ".p-slidemenu-rootlist": {
      position: "relative",
      width: "100% !important",
      ".p-menuitem": {
        width: "100% !important",
      },
      ".p-menuitem-link": {
        position: "relative",
        padding: 0,
        flex: 1,
        "&::before": {
          content: 'unset',
        },
        ".p-menuitem-icon": {
          display: "none",
          "&.fa": {
            display: "block",
          },
        },
        "&:focus": {
          boxShadow: "none",
        },
      },
      ".p-menuitem-icon.fa": {
        position: "absolute",
        right: 0,
        top: "50%",
        transform: "translateY(-50%)",
      },
      ".p-menuitem-link:not(.p-disabled):hover": {
        background: "transparent",
      },
      ".rollover-next-btn": {
        ".rollover-next-arrow": {
          width: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
        },
      },
    },
    ".p-slidemenu-backward": {
      textAlign: "left",
      fontWeight: "600",
      backgroundColor: submenuBackGroundStyle?.backgroundColor && submenuBackGroundStyle.backgroundColor.length > 0 ? submenuBackGroundStyle.backgroundColor : "#ffffff",
    },
  },
}))



const NavMenu = ({ strings, menuWhiteClass, sidebarMenu, divHeader }) => {
  const { themeSettingsData,
    categoriesList,
    staticPagesList,
    settingData,
    user,
    categoriesByUserGroup,
    loadingCategories,
    paymentMethodsSettings,
    defaultUserGroup,
    storeDetails
  } = useContext(AuthContext)
  const [dynamicmenuData, setDynamicmenuData] = useState([]);
  const {getSettingArrayByName} = usePaymentMethodSettings({ paymentMethodsSettings })
  const [menuStyle, setMenuStyle] = useState([]);
  const [staticPagesListData, setstaticPagesList] = useState([]);
  const [categoriesMenu, setCategoriesMenu] = useState([])
  const [menuPosition, setMenuPosition] = useState('justify-content-center')
  const [themeData, getThemeData] = useState("")
  const [showVoucherBalanceInMenu, setShowVoucherBalanceInMenu] = useState(false);
  const [showGiftCardBalanceInMenu, setShowGiftCardBalanceInMenu] = useState(false);
  const [reportUrlRequest, setReportUrlRequest] = useState({});
  const { data: reportUrlData } = useGetReportUrlQuery(reportUrlRequest)

  const {
    isordermoduleEnabled,
    expandSearchBarUnderHeaderMenu,
    defaultFont,
  } = useThemeSettings({ settingData })

  const {
    filterMenuItems
  } = useNavMenuFilter({
    user,
    defaultUserGroup
  })

  useEffect(() => {
    if(reportUrlData?.data?.url){
      window.open(reportUrlData.data.url,'_blank')
    }
  }, [reportUrlData])

  const { width } = useWindowDimensions({ divHeader });
  let arrayPosition = {};

  useEffect(() => {
    if (staticPagesList && staticPagesList.length > 0) {
      let tempData = staticPagesList.filter(staticPage => {
        if (staticPage.isEnabled) {
          if (staticPage.pageLocation === "header") {
            return staticPage;
          }
        }
        return false;
      })
      setstaticPagesList(tempData);
    }
  }, [staticPagesList])

  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0) {
      themeSettingsData.map((i) => {
        if (i.settingsName === "headerMenu") {

          if (i.values[0].menuItems) {
            const menuItems = filterMenuItems(i.values[0].menuItems);
            setDynamicmenuData(menuItems);
          }
          if (i.values[0].menuSettings) {
            setMenuStyle(i.values[0].menuSettings);
          }
        }
        if (i.settingsName === "theme") {

          if (i.values) {
            getThemeData(i.values[0]);
          }
        }
      })
    }
  }, [themeSettingsData,defaultUserGroup])

  useEffect(() => {
    loadCategories();
  }, [categoriesList, categoriesByUserGroup])

  useEffect(() => {
    if (paymentMethodsSettings && paymentMethodsSettings.length > 0) {
      const voucherConfig = getSettingArrayByName("voucherSettings") || {};
      const showVoucher = voucherConfig?.showInHeaderMenu ?? false;
      setShowVoucherBalanceInMenu(showVoucher);
      const giftCardConfig = getSettingArrayByName("giftcardSettings") || {};
      const showGiftCard = giftCardConfig?.showInHeaderMenu ?? false;
      setShowGiftCardBalanceInMenu(showGiftCard);
    }
  }, [paymentMethodsSettings])

  const getChildTree = (parentId) => {
    let treeTemp = []
    categoriesList.map(catArray => {

      if (catArray.parent_id === parentId && catArray.isVisibleOnTopMenu) {
        treeTemp.push({ title: catArray.categoryName, url: catArray.categoryName, expanded: true, id: catArray._id, children: getChildTree(catArray._id) });
      }
    });
    if(categoriesByUserGroup?.length > 0) {
       let newData = [];
       categoriesByUserGroup.forEach(categoryUserGroup => {
         treeTemp.forEach(data => {
           if(categoryUserGroup === data.id) {
             newData.push(data);
           }
         });
       });
      treeTemp = newData;
    }
    return treeTemp
  }
  const loadCategories = () => {
    let catDataArrange = [];
    if (categoriesList && categoriesList.length > 0) {
      categoriesList.map(catArray => {
        if (catArray.parent_id === "" && catArray.isVisibleOnTopMenu) {
          catDataArrange.push({ title: catArray.categoryName, url: catArray.categoryName, expanded: true, id: catArray._id, children: getChildTree(catArray._id) })
        }
      })
    }
     if(categoriesByUserGroup?.length > 0) {
       let newData = [];
       categoriesByUserGroup.forEach(categoryUserGroup => {
         catDataArrange.forEach(data => {
           if(categoryUserGroup === data.id) {
             newData.push(data);
           }
         });
       });
       setCategoriesMenu(newData);
     } else {
       setCategoriesMenu(catDataArrange);
     }
  }
  const getUrl = (link) => {
    const urlregex = new RegExp("^https?:\/\/(.*)");
    if (urlregex.test(link)) {
      if(link.includes(REPORT_BUILDER_PATH_NAME)){
        // if report url avoid default url redirection
        return '#';
      }else{
        return link;
      }
    }
    link = link?.replace(/ /g, "-")?.toLowerCase();
    if (link && link !== "" && link[0] === "/") {
      return link
    }
    return ("/page/" + (link ? link : ""))

  }

  const handleReportClick = (reportUrl) =>{
    setReportUrlRequest({
      accountId: storeDetails?.accountId ?? '',
      contactId:storeDetails?.contactId ?? '',
      storeUrl:storeDetails?.storeurl,
      userEmail: user.emailAddress ?? '',
      advanceReportUrl: reportUrl,
      timestamp: new Date().valueOf()   // to force new call when request the same report
    })
  }

  const getMenuClass = (level, parentClass, mainParent) => {

    if (level === 1) {
      return 'submenu-left';
    }


    const parentPosition = arrayPosition?.[mainParent]?.[level - 1];
    const parentRight = parentPosition?.right || 0;
    const parentLeft = parentPosition?.left || 0;

    const viewportWidth = Math.floor(width * 0.90);
    const submenuWidth = 250;
    const minLeftSpace = 20;

    if (parentClass === 'submenu-left') {

      if (parentRight + submenuWidth > viewportWidth) {
        return 'submenu-left'; 
      }
      return 'submenu-right'; 
    } else {

      if (parentLeft - submenuWidth < minLeftSpace) {
        return 'submenu-right'; 
      }
      return 'submenu-left'; 
    }
  }



  let rollOverResult = [];
  const recursion = (parentCat, data, parent, resulttemp, menuArray, submenuAnchorStyle) => {
    if (data && data.length > 0) {
      if (parent) {
        let temp = []
        let tempchild = resulttemp.length ? resulttemp.find((temp) => temp.id === parent) : [];
        data.map((items, i) => {
          temp.push({
            label: items?.title,
            icon: items?.children?.length ? 'fa fa-angle-right' : '',
            id: items?.id,
            template: (item, options) => {
              return (
                <div key={i}>
                  {
                    items?.children?.length ?
                      <div className="rollover-next-btn" style={{ display: "flex" }}>
                        <a href={`${process.env.PUBLIC_URL}/products/${parentCat}/${items?.url}`} role="menuitem" className={options.className} 
                         onMouseOver={(e) => e.target.style.color = menuStyle?.menuHovercolor}
                         onMouseOut={(e) => e.target.style.color = menuArray?.subMenufontColor || menuStyle?.subMenufontcolor || menuStyle?.menufontcolor}
                         style={submenuAnchorStyle} >
                          {items?.title}
                        </a>
                        <a style={submenuAnchorStyle} role="menuitem" className="rollover-next-arrow" target={item.target} onClick={options.onClick}
                        >
                          <i className="fa fa-angle-right" />
                        </a>
                      </div>
                      :
                      <a href={`${process.env.PUBLIC_URL}/products/${parentCat}/${items?.url}`} role="menuitem" className={'options.className'} 
                      onMouseOver={(e) => e.target.style.color = menuStyle?.menuHovercolor}
                      onMouseOut={(e) => e.target.style.color = menuArray?.subMenufontColor || menuStyle?.subMenufontcolor || menuStyle?.menufontcolor}
                      style={submenuAnchorStyle}>
                        {items?.title}
                      </a>
                  }
                </div>
              );
            }
          });
          if (tempchild.items) {
            tempchild.items = temp;
          }
          else{
            tempchild.items = [];
            tempchild.items =  temp;

          }
          if (items?.children?.length) {
            recursion(`${parentCat}/${items?.url}`, items.children, items.id, tempchild?.items || [], menuArray, submenuAnchorStyle);
          }
        });
      } else {
        rollOverResult = []
        data.map((items, i) => {
          rollOverResult.push({
            label: items?.title,
            icon: items?.children?.length ? 'fa fa-angle-right' :'',
            id: items?.id,
            template: (item, options) => {
              return (
                <div key={i}>
                  {
                    items?.children?.length ?
                      <div className="rollover-next-btn" style={{ display: "flex" }}>
                        <a href={`${process.env.PUBLIC_URL}/products/${parentCat}/${items?.url}`} role="menuitem" className={options.className}
                        onMouseOver={(e) => e.target.style.color = menuStyle.menuHovercolor}
                        onMouseOut={(e) => e.target.style.color = menuArray.subMenufontColor || menuStyle.subMenufontcolor || menuStyle.menufontcolor}
                        style={submenuAnchorStyle}>
                          {items?.title}
                        </a>
                        <a role="menuitem" className="rollover-next-arrow" target={item.target} onClick={options.onClick}
                        style={submenuAnchorStyle}>
                          <i className="fa fa-angle-right" />
                        </a>
                      </div>
                      :
                      <a href={`${process.env.PUBLIC_URL}/products/${parentCat}/${items?.url}`} role="menuitem" className={options.className}
                      onMouseOver={(e) => e.target.style.color = menuStyle.menuHovercolor}
                      onMouseOut={(e) => e.target.style.color = menuArray.subMenufontColor || menuStyle.subMenufontcolor || menuStyle.menufontcolor}
                      style={submenuAnchorStyle}
                      >
                        {items?.title}
                      </a>
                  }
                </div>
              );
            }
          })

          if (items?.children?.length) {
            recursion(`${parentCat}/${items?.url}`, items.children, items.id, rollOverResult, menuArray, submenuAnchorStyle);
          }
        });
      }
    }

    return rollOverResult;

  }


  const rollOverMenu = (parentCat, childCatArray, marginLeft, marginTop, menuArray, level, parentClass, mainParent) => {
    let submenuBackGroundStyle = {
      backgroundColor: menuArray?.subMenuBackgroundColor || (menuStyle?.subMenuBackgroundcolor),
    }
    let submenuAnchorStyle = {
      fontFamily: !!menuArray?.subMenufontName && menuArray?.subMenufontName !== ' ' ? menuArray?.subMenufontName 
        : !!defaultFont ? defaultFont : '"Poppins", sans-serif',
      color: menuArray?.subMenufontColor || menuStyle?.subMenufontcolor || menuStyle?.menufontcolor,
      fontSize: menuArray?.subMenufontSize + "px",
    }
    let getData = recursion(parentCat, childCatArray, null, null, menuArray, submenuAnchorStyle);

    let menuClass = getMenuClass(level, parentClass, mainParent);
    let addMax = childCatArray.filter(((childCat) => childCat?.title.length > 17)).length > 0

    return <>
      {
        childCatArray && childCatArray.length > 0 &&
        <RollOverMenu key={childCatArray.id} 
          className={menuClass}
          addMax={addMax}
          menuClass={menuClass}
          marginLeft={marginLeft}
          marginTop={marginTop}
          submenuBackGroundStyle={submenuBackGroundStyle}
          >
          <SlideMenu model={getData} viewportHeight={220} menuWidth={200}/>
        </RollOverMenu>
      }
    </>
  }

  const getChildMenu = (parentCat, childCatArray, marginLeft, marginTop, menuArray, level, parentClass, mainParent) => {
    let submenuBackGroundStyle = {
      backgroundColor: menuArray?.subMenuBackgroundColor || (menuStyle?.subMenuBackgroundcolor),
    }

    let submenuAnchorStyle = {
      fontFamily: !!menuArray?.subMenufontName && menuArray?.subMenufontName !== ' ' ? menuArray?.subMenufontName 
        : !!defaultFont ? defaultFont : '"Poppins", sans-serif',
      color: menuArray.subMenufontColor || menuStyle.subMenufontcolor || menuStyle.menufontcolor,
      fontSize: menuArray.subMenufontSize + "px",
    }
    if (childCatArray.length === 0) {
      return ""
    } else {
      let menuClass = getMenuClass(level, parentClass, mainParent);
		  let addMax = childCatArray.filter(((childCat) => childCat?.title.length > 17)).length>0
      return <ul key={childCatArray.id} className={`${menuClass}${addMax?` add-maxwidth`:``}`}
          style={{ marginRight: menuClass === 'submenu-right' ? (marginLeft + "%") : undefined, 
          marginLeft: menuClass === 'submenu-left' ? (marginLeft + "%") : undefined, 
          marginTop: (marginTop + "px"), backgroundColor: submenuBackGroundStyle?.backgroundColor }}> {childCatArray.map((childCat, index) => {
        let currentPosition = {left: 0, right: 0, width: 0}
        let parentPosition = arrayPosition[mainParent][level - 1];
        if(parentClass === 'submenu-left') {
          if(parentPosition?.right + 250 > Math.floor(width * 0.90)) {
            currentPosition.left = parentPosition?.right - 250 
            currentPosition.right = parentPosition?.right
          } else {
            currentPosition.left = parentPosition?.right
            currentPosition.right = parentPosition?.right + 250
          }
        } else {
          if(parentPosition?.left - 300 < 20) {
            currentPosition.left = parentPosition?.left
            currentPosition.right = parentPosition?.left + 250
          } else {
            currentPosition.left = parentPosition?.left - 250
            currentPosition.right = parentPosition?.left
          }
        }
        arrayPosition[mainParent][level] = {...currentPosition}
        return <li key={childCat.id} id={level+'category-link'+index}>
          <Link to={getProdustcatUrl(parentCat, childCat.title, "")}
            onMouseOver={(e) => e.target.style.color = menuStyle.menuHovercolor}
            onMouseOut={(e) => e.target.style.color = menuArray.subMenufontColor || menuStyle.subMenufontcolor || menuStyle.menufontcolor}
            style={submenuAnchorStyle}>
            {childCat.children.length > 0 && menuClass === 'submenu-right' ? (
              <i className="fa fa-angle-left" />
            ) : ""}
            {" "}
            {childCat.title} {" "}
            {childCat.children.length > 0 && menuClass === 'submenu-left' ? (
              <i className="fa fa-angle-right" />
            ) : ""} 
          </Link>
          {
            getChildMenu(parentCat + '/' + childCat.title, 
            childCat.children, 
            marginLeft, 
            marginLeft - 10,
            menuArray,
            level + 1, 
            menuClass,
            mainParent,
          )
          }
        </li>
      })
      }
      </ul >
    }
  }

  const getProdustcatUrl = (parentCal, Link, SubCat) => {
    Link = Link?.replace(/ /g, "-")?.toLowerCase();
    parentCal = parentCal.replace(/ /g, "-").toLowerCase();
    SubCat = SubCat.replace(/ /g, "-").toLowerCase();
    try {
      const url = new URL(Link);
      if (url.protocol === "http:" || url.protocol === "https:") {
        return Link;
      }
    } catch (error) {}
    if (Link && Link !== "" && Link[0] === "/") {
      if (SubCat !== "") {
        return "/products/" + parentCal + '/' + Link + '/' + SubCat
      } else if (Link !== "") {
        return "/products/" + parentCal + '/' + Link
      } else if (parentCal !== "") {
        return "/products/" + parentCal
      } else {
        return "/products/" + Link
      }

    } else {
      if (SubCat !== "") {
        return ("/products/" + parentCal + '/' + (Link ? Link : "")) + '/' + SubCat
      } else if (Link !== "") {
        return ("/products/" + parentCal + '/' + (Link ? Link : ""))
      }
      else if (parentCal !== "") {
        return ("/products/" + parentCal + '/' + (Link ? Link : ""))
      } else {
        return ("/products/" + (Link ? Link : ""))
      }

    }
  }
  const getCategoryMenu = (menuArray) => {
    if ( categoriesMenu && categoriesMenu.length > 0 ) {
      return categoriesMenu.map((category, index) => {
        let currentPosition = {left: 0, right: 0}
        let elem = document.getElementById("category-link"+index);
        let rect = elem?.getBoundingClientRect();
        currentPosition.left = rect?.left || 0;
        currentPosition.right = rect?.right || 0;
        if(!arrayPosition?.[category.title]) {
          arrayPosition[category.title] = []
        }
        arrayPosition[category.title][0] = {...currentPosition}
        let dataCategoryData = {}
        if(!!menuArray?.menuItemsSetColor) {
          let dataCategory = menuArray.menuItemsSetColor.find(res => res.id === category.id)
          if(!!dataCategory) {
            dataCategoryData = dataCategory
          }
        }
        return <li className="antera-header-menu-item categories-link" key={category.id} id={'category-link'+index}>
            <style>
              {`.cat-menu-items-link-${index}{
                font-family: ${!!menuArray?.fontName && menuArray?.fontName !== ' ' ? menuArray?.fontName
                    : !!defaultFont ? defaultFont : '"Poppins", sans-serif' } !important;
                font-size: ${menuArray?.fontSize + "px"} !important;
                color: ${menuArray?.menuFontColor || menuStyle?.menufontcolor} !important;
              }
              .cat-menu-items-link-${index}:hover{
                color: ${menuStyle?.menuHovercolor} !important;
              }              
                .menu-item-has-children a {
                  font-family: ${!!menuArray?.fontName && menuArray?.fontName !== ' ' ? menuArray?.fontName
                    : !!defaultFont ? defaultFont : '"Poppins", sans-serif' } !important;
                  font-size: ${menuArray?.fontSize + "px"} !important;
                  color: ${menuArray?.menuFontColor || menuStyle?.menufontcolor} !important;
                }
                .menu-item-has-children a:hover{
                    color: ${menuStyle?.menuHovercolor} !important;
                }
              `}

              {dataCategoryData && menuStyle.isIndividualColorMenu && `
                .cat-menu-items-link-${index}{
                    font-family: ${!!menuArray?.fontName && menuArray?.fontName !== ' ' ? menuArray?.fontName
                      : !!defaultFont ? defaultFont : '"Poppins", sans-serif' } !important;
                    background: ${ dataCategoryData?.menuItemBgColor} !important;
                    color : ${ dataCategoryData?.menuItemFontColor} !important;
                    transition: all 0.3s ease 0s
                } 
                .cat-menu-items-link-${index}:hover{
                  font-family: ${!!menuArray?.fontName && menuArray?.fontName !== ' ' ? menuArray?.fontName
                    : !!defaultFont ? defaultFont : '"Poppins", sans-serif' } !important;
                  background: ${ dataCategoryData?.menuItemBgHoverColor} !important;
                  color : ${ dataCategoryData?.menuItemFontHoverColor} !important;
                }`}
          </style>
          <Link to={getProdustcatUrl(category.title, "", "")}
            onMouseOver={(e) => getMouseHover(e)}
            onMouseOut={(e) => getMouseOut(e)}
            className={`cat-menu-items-link-${index}`}>
            {" "}
            {category.title}
            {category.children.length > 0 ? (
              <i className="fa fa-angle-down" />
            ) : ''}
          </Link>
          {
            menuStyle?.isRollingSubmenu === true ? <>
              {rollOverMenu(category.title, category.children, 0, 0, menuArray, 1, 'submenu-left', category.title)}
            </> : <>
              {getChildMenu(category.title, category.children, 0, 0, menuArray, 1, 'submenu-left', category.title)}
            </>
          }
        </li>
      })
    } else {
      return ""
    }
  }

  const getMouseHover = (event) => {
    // event.target.style.color = menuStyle.menuHovercolor
    let getCurrentElem = event.target.getBoundingClientRect();
    // let getNextElem = event?.target?.childNodes[1]
    let getNextElem = event?.target?.nextSibling
    if (!!getNextElem && getNextElem !== undefined && getNextElem.classList && getNextElem.classList[0] === "submenu-left") {
      getNextElem.style.left = `${getCurrentElem?.left + getCurrentElem?.width}px`;
      getNextElem.style.top = `${getCurrentElem?.top}px`;
    }
  }

  const getMouseOut = (event) => {
    event.target.style.color = menuStyle.menufontcolor
  }

  useEffect(() => {
    if(menuStyle?.menualignment == 'left'){
      setMenuPosition("justify-content-start")
    }
    if(menuStyle?.menualignment == 'center' || menuStyle?.menualignment == ''){
      setMenuPosition("justify-content-center")
    }
    if(menuStyle?.menualignment == 'right'){
      setMenuPosition("justify-content-end")
    }
  }, [menuStyle])


  return (
    <div
      className={`antera-header-menu-items-container ${sidebarMenu
        ? "sidebar-menu"
        : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
      } ${expandSearchBarUnderHeaderMenu === true ? 'pt-4' : ''}`}
      style={{ position: "unset" }}
    >
      <nav>
        <ul style={{ position: "unset" }} 
        className={`${(themeData?.themeName == 'beach' || themeData?.themeName == 'apparel') ? '' : 'd-flex' } flex-wrap ${menuPosition}`}>
          {dynamicmenuData && dynamicmenuData.length > 0 && dynamicmenuData.filter(menu => {
            if (menu.staticName && ( menu.staticName === "orders" ||  menu.staticName === "voucherbalance" ||  menu.staticName === "giftcardbalance")) {
              switch (menu.staticName){
                case "orders":{
                  return menu.isEnabled && isordermoduleEnabled && user;
                }
                case "giftcardbalance":{
                  return menu.isEnabled && showGiftCardBalanceInMenu && user;
                }
                case "voucherbalance":{
                  return menu.isEnabled && showVoucherBalanceInMenu && user;
                }
                default: {
                  return menu.isEnabled;
                }
              }
            } else {
              if (menu.staticName && menu.staticName === "addButton") {
                return false
              }
              return menu.isEnabled
            }
          }).map((menuArray, index) => {
            let submenuBackGroundStyle = {
              backgroundColor: menuArray?.subMenuBackgroundColor || (menuStyle?.subMenuBackgroundcolor),
            }
            let submenuAnchorStyle = {
              fontFamily: !!menuArray?.subMenufontName && menuArray?.subMenufontName !== ' ' ? menuArray?.subMenufontName 
                : !!defaultFont ? defaultFont : '"Poppins", sans-serif',
              color: menuArray.subMenufontColor || menuStyle.subMenufontcolor  || menuStyle.menufontcolor,
              fontSize: menuArray.subMenufontSize + "px",
            }

            if (menuArray.staticName && menuArray.staticName === "staticPage" && menuArray.isEnabled) {
              return staticPagesListData && staticPagesListData.length > 0 && 
              <li className="static-link" key={"li" + index} onMouseOver={(e) => getMouseHover(e)}>
                <style>
                  {`.menu-items-link-${index}{
                    font-family: ${!!menuArray?.fontName ? menuArray?.fontName 
                      : !!defaultFont ? defaultFont : '"Poppins", sans-serif'} !important;
                    font-size: ${menuArray?.fontSize + "px"} !important;
                    color: ${menuArray?.menuFontColor || menuStyle?.menufontcolor} !important;
                  }
                  .menu-items-link-${index}:hover{
                    color: ${menuStyle?.menuHovercolor} !important;
                  }`}

                  {menuStyle && menuStyle.isIndividualColorMenu && `
                    .menu-items-link-${index}{
                        font-family: ${!!menuArray?.fontName ? menuArray?.fontName 
                          : !!defaultFont ? defaultFont : '"Poppins", sans-serif'} !important;
                        background: ${ menuArray?.menuItemBgColor} !important;
                        color : ${ menuArray?.menuItemFontColor} !important;
                        transition: all 0.3s ease 0s
                    } 
                    .menu-items-link-${index}:hover{
                      font-family: ${!!menuArray?.fontName ? menuArray?.fontName 
                        : !!defaultFont ? defaultFont : '"Poppins", sans-serif'} !important;
                      background: ${ menuArray?.menuItemBgHoverColor} !important;
                      color : ${ menuArray?.menuItemFontHoverColor} !important;
                    }`}
                </style>
                <a className={`menu-items-link-${index}`} href={getUrl(menuArray.anchorLink)}
                  // onMouseOver={(e) => e.target.style.color = menuStyle.menuHovercolor}
                  // onMouseOut={(e) => e.target.style.color = menuArray.menuFontColor || menuStyle.menufontcolor}
                  // style={menuAnchorStyle}
                  >
                  {menuArray.name}
                  {(sidebarMenu) ? (
                    <span>
                      <i className="fa fa-angle-right"/>
                    </span>
                  ) : (
                    <i className="fa fa-angle-down" />
                  )}
                </a>
                <ul className="submenu-left" style={submenuBackGroundStyle}>
                  {staticPagesListData && staticPagesListData.length > 0 && staticPagesListData.filter(staticPage => !staticPage.isBreakoutHtml).map((staticPage, index) => {
                    return <li key={index}><a href={getUrl(staticPage?.pageLink)}
                      onMouseOver={(e) => e.target.style.color = menuStyle.menuHovercolor}
                      onMouseOut={(e) => e.target.style.color = menuStyle.subMenufontcolor || menuStyle.menufontcolor}
                      style={submenuAnchorStyle}>
                      {staticPage.pageName}
                    </a></li>
                  })}
                </ul>
              </li>
            }

            if (!loadingCategories && menuArray.staticName && menuArray.staticName === "categories" && menuArray.isEnabled) {
              return getCategoryMenu(menuArray)
            }
            return <li className="antera-header-menu-item menu-other-link" onMouseOver={(e) => getMouseHover(e)} key={index} style={{ position: (menuArray.isSubmenu && menuArray.subMegaMenu) ? "unset" : "" }}>
              <style>
                  {`.menu-items-link-${index}{
                    font-family: ${!!menuArray?.fontName ? menuArray?.fontName
                      : !!menuArray?.subMenufontName ? menuArray?.subMenufontName
                      : !!defaultFont ? defaultFont : '"Poppins", sans-serif' } !important;
                    font-size: ${menuArray?.fontSize + "px"} !important;
                    color: ${menuArray?.menuFontColor || menuStyle?.menufontcolor} !important;
                  }
                  .menu-items-link-${index}:hover{
                    color: ${menuStyle?.menuHovercolor} !important;
                  }`}

                  {menuStyle && menuStyle.isIndividualColorMenu && `
                    .menu-items-link-${index}{
                        font-family: ${!!menuArray?.fontName ? menuArray?.fontName
                          : !!menuArray?.subMenufontName ? menuArray?.subMenufontName
                          : !!defaultFont ? defaultFont : '"Poppins", sans-serif' } !important;
                        background: ${ menuArray?.menuItemBgColor} !important;
                        color : ${ menuArray?.menuItemFontColor} !important;
                        transition: all 0.3s ease 0s
                    } 
                    .menu-items-link-${index}:hover{
                      font-family: ${!!menuArray?.fontName ? menuArray?.fontName
                        : !!menuArray?.subMenufontName ? menuArray?.subMenufontName
                        : !!defaultFont ? defaultFont : '"Poppins", sans-serif' } !important;
                      background: ${ menuArray?.menuItemBgHoverColor} !important;
                      color : ${ menuArray?.menuItemFontHoverColor} !important;
                    }`}
                </style>
              <a href={getUrl(menuArray.anchorLink)}
                target={menuArray?.opneNewTab ? '_blank' : ''}
                className={`menu-items-link-${index}`}
                 onClick={menuArray.anchorLink.includes(REPORT_BUILDER_PATH_NAME) ? ()=>{handleReportClick(menuArray.anchorLink)} : null}
                // onMouseOver={(e) => e.target.style.color = menuStyle.menuHovercolor}
                // onMouseOut={(e) => e.target.style.color =   menuArray.menuFontColor || menuStyle.menufontcolor}
                // style={menuAnchorStyle}
                >
                {menuArray.name}
                {menuArray.isSubmenu ? (sidebarMenu) ? (
                  <span>
                    <i className="fa fa-angle-right"/>
                  </span>
                ) : (
                  <i className="fa fa-angle-down" />
                ) : ""}
              </a>
              {menuArray.isSubmenu && <>
                {menuArray.subMegaMenu && menuArray.submegaMenuitems &&
                  <ul className="mega-menu" style={submenuBackGroundStyle}>
                    {
                      menuArray?.submegaMenuitems?.imageList && menuArray?.submegaMenuitems?.imageList.length > 0 && 
                    
                    <li style={{minWidth: "100%", overflow: "auto" }} >
                      {
                      <ul className={`imageUl ${menuArray?.submegaMenuitems?.menuItemsLi && menuArray?.submegaMenuitems?.menuItemsLi.length === 0 ? "removeBottom" : ""}`}>
                          {menuArray.submegaMenuitems.imageList && menuArray.submegaMenuitems.imageList.length > 0 && menuArray.submegaMenuitems.imageList.map((imageArray, imgKey) => {
                            return <li key={index + "img" + imgKey}>
                              <a
                                onMouseOver={(e) => e.target.style.color = imageArray?.menuFontHovercolor || menuStyle.menuHovercolor}
                                onMouseOut={(e) => e.target.style.color = imageArray?.menuFontColor || menuArray.subMenufontColor || menuStyle.subMenufontcolor || menuStyle.menufontcolor}
                                style={submenuAnchorStyle}
                                href={getUrl(imageArray.anchorLink)} 
                                target={imageArray?.opneNewTab ? '_blank' : ''}>
                                <img
                                  style={{ maxHeight: "200px", maxWidth: "150px" }}
                                  src={imageArray.imageLink}
                                  alt=""
                                />
                              </a>
                              <a
                                onMouseOver={(e) => e.target.style.color = imageArray?.menuFontHovercolor || menuStyle.menuHovercolor}
                                onMouseOut={(e) => e.target.style.color = imageArray?.menuFontColor || menuArray.subMenufontColor || menuStyle.subMenufontcolor || menuStyle.menufontcolor}
                                style={submenuAnchorStyle}
                                className="text-center" href={getUrl(imageArray.anchorLink)}
                                target={imageArray?.opneNewTab ? '_blank' : ''}>
                                <b>{imageArray.title}</b>
                              </a>
                              <ul className="imageUI submenu">
                                {imageArray?.submenuItem && imageArray?.submenuItem?.length > 0 && imageArray?.submenuItem.map((res, i) => {
                                  return <div key={i}>
                                    <li><a
                                      onMouseOver={(e) => e.target.style.color = menuStyle.menuHovercolor}
                                      onMouseOut={(e) => e.target.style.color = menuArray.subMenufontColor || menuStyle.subMenufontcolor || menuStyle.menufontcolor}
                                      style={submenuAnchorStyle}
                                      className="text-center"
                                      href={getUrl(res.anchorLink)}
                                      target={res?.opneNewTab ? '_blank' : ''}>
                                      {res.name}
                                    </a></li>
                                  </div>
                                })
                                }
                              </ul>
                            </li>
                          })}
                        </ul>

                      } </li>
                    }
                    {
                      menuArray?.submegaMenuitems?.menuItemsLi && menuArray?.submegaMenuitems?.menuItemsLi.length > 0 &&
                   
                    <li style={{ width: "100%" }}>
                      <ul className="bottomMenu" style={submenuBackGroundStyle}>
                        {menuArray.submegaMenuitems.menuItemsLi && menuArray.submegaMenuitems.menuItemsLi.length > 0 && menuArray.submegaMenuitems.menuItemsLi.map((menuItemArray, menuKey) => {
                          return <li className={"magamenuLi"} key={index + "sibmenuitem" + menuKey} style={{ borderLeft: "0px solid lightgray" }}>
                            <ul  className="">
                              {menuItemArray.items && menuItemArray.items.length > 0 && menuItemArray.items.map((item, itemKey) => {
                                return <li className={itemKey === 0 ? "mega-menu-title" : ""} key={index + "img" + itemKey}>
                                  <a
                                    onMouseOver={(e) => e.target.style.color = menuStyle.menuHovercolor}
                                    onMouseOut={(e) => e.target.style.color = menuArray.subMenufontColor || menuStyle.subMenufontcolor || menuStyle.menufontcolor}
                                    style={submenuAnchorStyle}
                                    href={getUrl(item.anchorLink)}
                                    target={item?.opneNewTab ? '_blank' : ''} >
                                    {itemKey > 0 ? ">" : ""} {item.name}
                                  </a>
                                </li>
                              })}
                            </ul>
                          </li>
                        })}
                      </ul>
                    </li>
                     }
                  </ul>

                }
              </>}
              {menuArray.subMenus && menuArray.subMenuitems && menuArray.subMenuitems.length > 0 && <>
                <ul className={`submenu-left${menuArray?.subMenuitems.filter(((subMenuArray) => subMenuArray?.name.length > 17)).length>0?` add-maxwidth`:``}`}style={submenuBackGroundStyle}>
                  {menuArray.subMenuitems.map((subMenuArray, subIndex) => {
                    return <li key={subIndex}>
                      <a href={subMenuArray.anchorLink ? getUrl(subMenuArray.anchorLink) : ""}
                         onClick={subMenuArray.anchorLink.includes(REPORT_BUILDER_PATH_NAME) ? ()=>{handleReportClick(subMenuArray.anchorLink)} : null}
                         onMouseOver={(e) => e.target.style.color = menuStyle.menuHovercolor}
                        onMouseOut={(e) => e.target.style.color = menuArray.subMenufontColor  || menuStyle.subMenufontcolor || menuStyle.menufontcolor}
                        style={submenuAnchorStyle}
                        target={subMenuArray?.opneNewTab ? '_blank' : ''} >
                        {subMenuArray.name}
                      </a>
                    </li>
                  })}
                </ul>
              </>}
            </li>
          })}
        </ul>
      </nav>
    </div >
  );
};

NavMenu.propTypes = {
  menuWhiteClass: PropTypes.string,
  sidebarMenu: PropTypes.bool,
  strings: PropTypes.object
};

export default multilanguage(NavMenu);
